
<template>
  <crud-modal
    :title="$t('modals.user.reactivateEmailTitle')"
    action="update"
    :on-submit="submit"
    :on-close="() => $emit('close')"
  >
    <div class="mb-10">
      {{ $t('modals.user.reactivateEmailPrefix') }}
      <span class="font-semibold">"{{ email }}"</span>
      {{ $t('modals.user.reactivateEmailSuffix') }}
    </div>

    <p v-if="state === 'MANUAL_SUPPRESSION'">
      {{ $t('modals.user.manualSuppressionInfo', { platform: readablePlatformName }) }}
    </p>
    <p v-if="state === 'HARD_BOUNCE'">
      {{ $t('modals.user.hardBounceInfo') }}
    </p>

    <p class="mt-10">
      {{ $t('modals.user.reactivateWarning', { platform: readablePlatformName }) }}
    </p>
  </crud-modal>
</template>

<script>
import CrudModal from '@/components/modals/crud-modal'
import brandingMixin from '@/mixins/branding'

export default {
  components: { CrudModal },
  mixins: [brandingMixin],
  props: {
    email: {
      type: String,
      required: true
    },
    onSubmit: {
      type: Function,
      default: () => {}
    },
    state: {
      type: String,
      default: ''
    }
  },
  methods: {
    async submit () {
      this.onSubmit()
    }
  }
}
</script>
